import HTTPClient from './http-client';

const options = {
  cache: {
    maxAge: 1 * 60 * 60 * 1000, // 1 hour
    exclude: { query: false }
  }
}

const END_POINT = '/landuse_evolution';

const loadSiaEvolution = async (locacronymn) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}?name=${locacronymn}`,
    options
  );
}

export {
  loadSiaEvolution
}
